<label *ngIf="showLabel" [for]="name" class="text-[0.9rem] text-gray-600 tracking-wide mb-2">{{ name }}</label>
<div #popoverRef class="relative flex items-center">
  <input
    [id]="name"
    [name]="name"
    [disabled]="disabled"
    [placeholder]="showPlaceholder ? name : ''"
    [value]="option"
    (blur)="blur.emit()"
    (focus)="focus.emit()"
    (click)="popover.open()"
    class="arrow-icon w-full rounded border text-[0.9rem] placeholder-gray-400 focus:border-purple-400 focus:outline-none disabled:text-gray-600 px-3 py-2"
    [class.border-red-400]="hasError"
    autocomplete="none"
    readonly
  />
  <clr-icon (click)="value = $any(undefined)" class="relative right-4 top-0" shape="times"></clr-icon>
</div>

<div class="h-4 pt-1">
  <app-input-errors *ngIf="hasError" [errors]="ngControl?.control?.errors!"></app-input-errors>
</div>

<app-popover [reference]="popoverRef" #popover>
  <div class="popover bg-white rounded shadow-xl p-4">
    <div *ngIf="data && data.length === 0; else options">No data</div>
    <ng-template #options>
      <input
        *ngIf="showSearch"
        type="text"
        placeholder="Search"
        class="w-full text-[0.9rem] rounded border p-2 mb-3"
        (keyup)="search$.next($any($event.target).value)"
      />
      <div *ngFor="let option of filteredData" (click)="value = option[valueKey]; popover.close()" class="text-sm hover:text-blue-700 cursor-pointer mb-1">
        {{ option[titleKey] }}
      </div>
    </ng-template>
  </div>
</app-popover>
